import { forwardRef } from "react";
import { NavLinkProps } from "react-router-dom";

import { StyledNavLink } from "./IconNavLink.styles";

type IconNavLinkProps = NavLinkProps & {
  children: React.ReactNode;
  activeIcon?: React.ReactNode;
};

export const IconNavLink: React.FC<IconNavLinkProps> = forwardRef(
  ({ children, activeIcon, ...props }: IconNavLinkProps, ref: React.Ref<HTMLAnchorElement>) => {
    return (
      <StyledNavLink ref={ref} {...props} className="icon-navlink">
        {({ isActive }) => (activeIcon && isActive ? activeIcon : children)}
      </StyledNavLink>
    );
  }
);
IconNavLink.displayName = "IconNavLink";
